import type { IntentClassificationData, NavigationalIntent } from './types';

export const isNavigationalIntent = (
	intent: IntentClassificationData,
): intent is NavigationalIntent => intent.__typename === 'KnowledgeDiscoveryNavigationalIntent';
